import * as React from 'react';

interface TFFButtonProps {
  buttonText: string;
  id?: string;
  outline?: boolean;
  disabled?: boolean;
  variant?: 'primary' | 'promotion' | 'secondary' | 'tertiary' | 'error' | 'success';
  handleClick?: () => void;
  type?: 'button' | 'submit';
  size?: 'medium' | 'large' | 'xlarge';
}

export const TFFButton: React.FC<TFFButtonProps> = ({
  buttonText,
  disabled,
  handleClick,
  outline,
  variant = 'primary',
  type = 'button',
  size,
  id,
}) => {
  return (
    <button
      id={id}
      className={`button ${variant}  ${size ?? 'medium'}${outline ? ' outline' : ''}`}
      type={type}
      disabled={disabled}
      onClick={handleClick || undefined}
    >
      {buttonText}
    </button>
  );
};

export default TFFButton;
